import {combineReducers} from 'redux';
import user, * as fromUser from './userReducer'; // default랑 const들 가져옴

// 이하 예제
// const getAddedIds = state => fromCart.getAddedIds(state.cart);
// const getQuantity = (state, id) => fromCart.getQuantity(state.cart, id);
// export const getCartProducts = state =>
//   getAddedIds(state).map(id => ({
//     ...getProduct(state, id),
//     quantity: getQuantity(state, id),
//   }));

export const getUserAuth = state => fromUser.getUserAuth(state.user);
export const getUserInfo = state => fromUser.getUserInfo(state.user);

export default combineReducers({
  user,
});
